module.exports = __webpack_public_path__ + "img/order-online.e9701ae7.jpg";